// extracted by mini-css-extract-plugin
export var arrowsContainer = "hero-banner-module--arrowsContainer--42f2d";
export var card = "hero-banner-module--card--50776";
export var heroBanner = "hero-banner-module--heroBanner--a09a4";
export var image = "hero-banner-module--image--cce44";
export var leftContainer = "hero-banner-module--leftContainer--aa076";